import { sendPackageOperationalEvent } from '../../../../common/utils';
import { Logger } from '../../../../common/utils/logger';

export const getIndexedDBOpenOverride =
	(originalOpen: (name: string, version?: number) => IDBOpenDBRequest) =>
	(databaseName: string, version?: number): IDBOpenDBRequest => {
		try {
			// Send analytics event for uncategorized IndexedDB usage
			sendPackageOperationalEvent({
				action: 'usedIndexedDBOpenUncategorized',
				attributes: {
					databaseName,
				},
			});
		} catch (e: any) {
			Logger.error(`Failed to send IndexedDB open event. ${e.message || ''}`);
		}

		// Always allow the operation to proceed (we're only tracking usage)
		return originalOpen.call(window.indexedDB, databaseName, version);
	};
